(function (app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.Applications.EApp2",
            {
                url: "/EApps2",
                component: "eapplications2",
                PageTitle: "E-Applications"
            });
        }
    ]);

    app.component("eapplications2",
    {
        templateUrl: "App/Tools/Applications/eApps/eApps2.html",
        controller: "eApps2Ctrl"
    });


    app.controller("eApps2Ctrl", ["eappApi", "$http", "externalLoading", function (eappApi, $http, externalLoading) {
        var $ctrl = this;

        this.ActivateFirelightSso = function () {
            //console.log(this.SamlData);
            var w = window.open();
            w.document.write(externalLoading.html);
            eappApi.initiateFirelightSso2(this.SamlData).then(function (data) {
                console.log(data);                
                w.document.write(data);
                w.document.forms.samlform.submit();
            }, function (error) {
                w.document.write(" Failed.  There was an error accessing this resource.");
            });
        };

        this.ActivateIpipelineSso = function (rsid) {           
            var w = window.open();
            w.document.write(externalLoading.html);
            eappApi.initiateIpipelineSso(rsid).then(function (data) {
                //console.log(data);          
                w.document.write(data);
                w.document.forms.samlform.submit();
            }, function (error) {
                w.document.write(" Failed.  There was an error accessing this resource.");
            });
        }
    }]);

})(window.app); // jshint ignore:line